import NotificationModal from "@/components/common/NotificationModal";
import { asyncModal } from "@/components/ui/modal/utils";

export default function showNotify(options, type) {
  return asyncModal({
    name: `notification-modal ${type}`,
    component: NotificationModal,
    props: {
      options,
      type
    }
  });
}
